import type { Business } from '../../types';
import { Sheet } from './Sheet';

interface CallOutcomeSheetProps {
  business: Business;
  onSuccess: () => void;
  onNoAnswer: () => void;
  onRefused: () => void;
  onClose: () => void;
  busy: boolean;
}

/**
 * Demande l'issue d'un appel au retour sur l'appli.
 *
 * Armée au clic sur le bouton téléphone, elle s'ouvre quand l'onglet redevient
 * visible (voir `App.tsx`) — un raccourci imparfait, la seule façon de deviner
 * un retour d'appel côté navigateur, mais suffisant pour éviter un geste de
 * saisie après chaque appel.
 *
 * Trois issues, jamais plus : c'est ce qu'on sait dire juste après avoir
 * raccroché, pas un formulaire de compte-rendu.
 */
export function CallOutcomeSheet(props: CallOutcomeSheetProps) {
  const { business } = props;

  return (
    <Sheet onClose={props.onClose} label={`Issue de l'appel avec ${business.name}`}>
      <h2 className="sheet-title">Comment s'est passé l'appel ?</h2>
      <p className="sheet-meta">{business.name}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
        <button
          type="button"
          className="btn btn-go btn-block"
          onClick={props.onSuccess}
          disabled={props.busy}
        >
          Réussi — fixer un RDV
        </button>
        <button
          type="button"
          className="btn btn-soft btn-block"
          onClick={props.onNoAnswer}
          disabled={props.busy}
        >
          Pas de réponse
        </button>
        <button
          type="button"
          className="btn btn-danger btn-block"
          onClick={props.onRefused}
          disabled={props.busy}
        >
          Refusé
        </button>
      </div>

      <button
        type="button"
        className="btn btn-ghost btn-block"
        style={{ marginTop: 6 }}
        onClick={props.onClose}
        disabled={props.busy}
      >
        Plus tard
      </button>
    </Sheet>
  );
}
